import axios from '../Axios/Default';
import { handleResponse } from '../Utils/Utils';

export const getPclAll = (_params, onSuccess, onError) => {
    const response = axios.get('v1/admin/part-change', { params: _params });
    return handleResponse(response, onSuccess, onError);
};

export const getPclById = (id, onSuccess, onError) => {
    const response = axios.get(`v1/admin/part-change/${id}`);
    return handleResponse(response, onSuccess, onError);
};

export const createPcl = (payload, onSuccess, onError) => {
    const response = axios.post(`v1/admin/part-change`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const updatePcl = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/part-change/${id}`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const softDeletePcl = (id, payload, onSuccess, onError) => {
    const response = axios.put(`v1/admin/part-change/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

export const deletePcl = (id, onSuccess, onError) => {
    const response = axios.delete(`v1/admin/part-change/${id}`);
    return handleResponse(response, onSuccess, onError);
};